// The primary button on the Flutter auth screens: black fill, white text and
// 1.5px white border, 20px radius, 50/15 padding, letter-spaced 20px label.

import React from 'react';
import { Button } from '@mui/material';

export default function AuthButton({ children, ...props }) {
  return (
    <Button
      variant="contained"
      disableElevation={false}
      sx={{
        bgcolor: '#000',
        color: '#fff',
        px: 6.25,
        py: 1.875,
        borderRadius: '20px',
        border: '1.5px solid #fff',
        fontSize: 20,
        fontWeight: 600,
        letterSpacing: '1.2px',
        textTransform: 'none',
        boxShadow: '0 6px 12px rgba(255,255,255,0.3)',
        '&:hover': { bgcolor: '#000' },
      }}
      {...props}
    >
      {children}
    </Button>
  );
}
